// @flow
import React, { type Node } from 'react';
import { get } from 'lodash';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import { urlCatalog } from 'angieslist-app-platform';
import { Alert, Grid, Row, Col, ButtonToolbar, Button } from 'angieslist-react-components';
import Helmet from 'react-helmet-async';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import * as addressActions from '../common/addressesActions';
import AddressDisplayCardComponent from './components/AddressDisplayCard';

type Props = {
  params: {
    serviceProviderId: string,
  },
  getSPAddresses: typeof addressActions.getSPAddresses,
  addressesResponse: Object,
};

export class AddressManagementViewComponent extends React.Component<Props> {
  componentDidMount() {
    this.props.getSPAddresses(this.props.params.serviceProviderId);
  }
  props: Props;

  render(): Node {
    const { addressesResponse } = this.props;
    const isLoading = get(addressesResponse, 'addressesInfo.isLoading');
    const allAddresses = get(addressesResponse, 'addressesInfo.response.addresses', []);
    const error = get(addressesResponse, 'addressesInfo.error');

    return (
      <Grid>
        <Helmet title="Address Management" />
        <Row>
          <Col xs={12}>
            <h1>Address Management</h1>
            <ButtonToolbar style={{ marginTop: '1em', marginBottom: '1em' }}>
              <Button id="address-edit-button" bsStyle="primary-office" flat>
                <i className="icon icon-plus-circled" /> Add Address&nbsp;&nbsp;
              </Button>
            </ButtonToolbar>
            <If condition={error}>
              <Alert bsStyle="danger">Oops, something went wrong and we were unable to retrieve your addresses.
                Let us help you by contacting <a id="address-management--error-phone-link" href={urlCatalog.global.businessCenterPhone()}>{urlCatalog.global.businessCenterPhoneText()}</a>.
              </Alert>
            </If>
            <Loader
              loading={isLoading}
              element={
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2em' }}>
                  <i className="icon icon-load icon-spin icon-5x text-primary" />
                </div>}
            >
              <AddressDisplayCardComponent
                addresses={allAddresses}
              />
            </Loader>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default (hot(module)(compose(
  connect(
    state => ({
      addressesResponse: state.addresses,
    }),
    { ...addressActions },
  ),
  pure,
)(AddressManagementViewComponent)): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/AddressManagementView.js